export const WHATSAPP_NUMBER = "5511993062119";
export const PHONE_DISPLAY = "(11) 99306-2119";
export const INSTAGRAM_HANDLE = "@brandaomoraishigienizacao";
export const INSTAGRAM_URL = "https://instagram.com/brandaomoraishigienizacao";

export const ADDRESS = "Guarulhos • Arujá • Itaquaquecetuba • Santa Isabel";
export const BUSINESS_HOURS = "Segunda a sábado, das 08h às 20h";

export const whatsappLink = (message) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
        message ||
            "Olá! Vim pelo site da Brandão Morais Higienização e gostaria de solicitar um orçamento."
    )}`;

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

export const SERVICES = [
    {
        icon: "Sofa",
        title: "Higienização de Estofados",
        description:
            "Limpeza profunda de estofados em geral, removendo sujeiras, ácaros e odores com produtos e equipamentos adequados.",
    },
    {
        icon: "Armchair",
        title: "Higienização de Sofás",
        description:
            "Cuidado completo para o seu sofá: higienização profunda que renova a aparência e prolonga a vida útil do tecido.",
    },
    {
        icon: "BedDouble",
        title: "Higienização de Colchões",
        description:
            "Um colchão higienizado contribui para noites de sono mais saudáveis, livre de ácaros, fungos e impurezas.",
    },
    {
        icon: "Chair",
        title: "Higienização de Cadeiras",
        description:
            "Cadeiras e poltronas limpas e higienizadas, ideais para residências, escritórios e ambientes comerciais.",
    },
    {
        icon: "Layers",
        title: "Higienização de Tapetes",
        description:
            "Limpeza cuidadosa de tapetes, preservando fibras e cores enquanto remove sujeiras acumuladas no dia a dia.",
    },
    {
        icon: "SprayCan",
        title: "Limpeza Profissional",
        description:
            "Serviços de limpeza profissional com atenção a cada detalhe, para ambientes limpos, seguros e bem cuidados.",
    },
    {
        icon: "Droplets",
        title: "Impermeabilização",
        description:
            "Proteção de estofados contra líquidos e manchas, facilitando a manutenção e aumentando a durabilidade.",
    },
    {
        icon: "Car",
        title: "Higienização Automotiva",
        description:
            "Bancos e interior do seu carro limpos e higienizados, com o mesmo cuidado dedicado aos estofados da sua casa.",
    },
];

export const DIFFERENTIALS = [
    {
        title: "Atendimento personalizado",
        description:
            "Cada cliente e cada ambiente têm necessidades únicas. Ouvimos você e indicamos o serviço ideal para o seu caso.",
    },
    {
        title: "Profissionais capacitados",
        description:
            "Equipe treinada para executar cada serviço com técnica, segurança e respeito ao seu espaço.",
    },
    {
        title: "Produtos e equipamentos adequados",
        description:
            "Utilizamos produtos e equipamentos apropriados para cada tipo de material, garantindo eficiência sem agredir o estofado.",
    },
    {
        title: "Cuidado com cada detalhe",
        description:
            "Do primeiro contato à finalização do serviço, tratamos o seu ambiente com o cuidado que ele merece.",
    },
    {
        title: "Compromisso com a satisfação",
        description:
            "Nosso trabalho só termina quando você está satisfeito. Qualidade e confiança em cada atendimento.",
    },
];

export const NAV_LINKS = [
    { id: "sobre", label: "Sobre nós" },
    { id: "servicos", label: "Serviços" },
    { id: "diferenciais", label: "Diferenciais" },
    { id: "antes-depois", label: "Antes e Depois" },
    { id: "depoimentos", label: "Depoimentos" },
    { id: "galeria", label: "Galeria" },
    { id: "contato", label: "Contato" },
];

export const IMAGES = {
    hero: "https://images.pexels.com/photos/4401538/pexels-photo-4401538.jpeg?auto=compress&cs=tinysrgb&w=1600",
    about: "https://images.unsplash.com/photo-1686178827149-6d55c72d81df?auto=format&fit=crop&w=1200&q=80",
    upholstery: "https://images.unsplash.com/photo-1590251024078-8a6d9f90b02d?auto=format&fit=crop&w=1400&q=80",
    rug: "https://images.pexels.com/photos/4107284/pexels-photo-4107284.jpeg?auto=compress&cs=tinysrgb&w=1200",
    mattress: "https://images.pexels.com/photos/8089076/pexels-photo-8089076.jpeg?auto=compress&cs=tinysrgb&w=1200",
    beforeAfter: "https://images.pexels.com/photos/4107278/pexels-photo-4107278.jpeg?auto=compress&cs=tinysrgb&w=1400",
    heroSofa: "/photos/depois-sofa-azul.jpg",
};
